@import url("https://www.ericsson.com/static/styles/global.bundle.css?v=1091695220");

.nested-menu-title {
  color: #242424;
  background-color: transparent;
  line-height: 1.75rem;
  font-size: 1.375rem;
  font-weight: 500;
  text-align: left;
  display: inline-block;
  vertical-align: top;
  padding: .75rem;
}

.e-features {
  >div {
    display: flex;
    flex-direction: column;
    align-items: anchor-center;
    max-width: max-content;
    width: 250px;

    h3 {
      margin-top: 1rem;
    }

    p {
      text-align: center;
    }

    .img-wrapper,
    .e-feature-item__image {
      align-self: center;
      background-color: black;
      justify-self: anchor-center;
      flex-shrink: 0;
      display: grid;
      place-items: center;
      height: 64px;
      width: 64px;
      padding: 15px;
      margin-left: auto;
      margin-right: auto;

      img {
        height: 100%;
      }
    }

  }
}

.e-header__backdrop {
  background-color: rgba(0, 0, 0, 0.54);
  bottom: 0;
  box-sizing: border-box;
  color: rgb(36, 36, 36);
  display: block;
  font-family: "Ericsson Hilda", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  height: 100%;
  left: 0;
  line-height: 24px;
  position: fixed;
  right: 0;
  text-rendering: optimizelegibility;
  top: 56px;
  transform: matrix(1, 0, 0, 1, 0, 0);
  transition: transform 0s linear 0.2s, opacity 0.1s ease-in-out 0.1s;
  width: 100%;
  will-change: transform, opacity;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  opacity: 0;
}

.e-header__backdrop.show {
  z-index: 999;
}

#globalSearchForm {
  width: 100%;
  height: 56px;

  &.isSearching {
    display: grid;
    grid-template-columns: 16fr 1fr;
    background-color: #242424;

    .input-container {
      border-color: #767676;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 12px;
    }

    .search-input {
      border-color: #767676;
      color: #fff;
      border-color: #767676 !important;
      padding-left: 2.5rem;
      margin: 0;
    }

    .icon-search {
      position: absolute;
      z-index: 10;
      top: 50%;
      margin-top: -1rem;
      left: .75rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 .75rem;
      line-height: 2rem;
      font-size: 1rem;
      color: #767676;
    }

    .search-cancel {
      background-color: #242424;
      color: #fff;
      padding: 0;
    }
  }
}

.e-header__center-wrap.default {
  height: 0;
  opacity: 0;

  &.show {
    height: auto;
    opacity: 1;
    width: 100%;
  }
}

.e-header__center-wrap.search {
  height: 0;
  opacity: 0;

  &.show {
    height: auto;
    opacity: 1;
  }
}

.global-search-container {
  background-color: rgba(0, 0, 0, 0.54);
  box-sizing: border-box;
  color: rgb(36, 36, 36);
  display: block;
  font-family: "Ericsson Hilda", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  position: fixed;
  text-rendering: optimizelegibility;
  transform: matrix(1, 0, 0, 1, 0, 0);
  transition: transform 0s linear 0.2s, opacity 0.1s ease-in-out 0.1s;
  will-change: transform, opacity;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  overflow: hidden;
  pointer-events: auto;
  width: 100vw;
  z-index: 9999;
  /* position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0; */

  /* */
  opacity: 1;
  height: 100vh;
  /* */

  /* show and hide search */
  /* opacity: 0;
    height: 0;

    &.show {
        opacity: 1;
        height: 100vh;
    } */

  form {
    display: flex;
    height: 120px;
    width: 100%;
    padding: 40px 120px;
    background-color: white;
  }

  input[type=text]:not(:disabled) {
    border: none;
    ;
    width: 95%;
    display: block;
    background-color: var(--cwc-color-white, #fff);
    font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
    font-size: 24px !important;

    outline: none;
    border-radius: 0;
    box-shadow: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    &:focus,
    &:active,
    &:hover {
      outline: none;
      border: none;
      box-shadow: none;
      outline: none;
      border-radius: 0;
      box-shadow: none;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
    }

    &::placeholder {
      font-size: 24px !important;

    }
  }

  span {
    cursor: pointer;
    width: 5%;

    svg {
      width: 40px;
      height: 40px;
    }
  }
}

/* International Dropdown Styles */
.international-dropdown {
  display: none;
  position: absolute;
  background-color: white;
  margin-top: 6px;
  padding: 0;
  list-style: none;
  width: 350px;
  z-index: 99;
  left: auto;
  top: 50px;
  right: 0;
  z-index: 9999;

  &.show {
    display: block;
  }

  .dropdown-item {
    padding: 10px;

    &.placeholder {
      cursor: default;
    }

    &.selectable {
      cursor: pointer;

      a {
        color: black;

        &:hover {
          color: white;
        }
      }

      &:hover {
        background-color: #007bff;
        color: white;
      }
    }
  }
}

/* SIDE_EFFECTS */
/* prevents background from scrolling, wherever instantiated */
html.freeze {
  height: min-content;
  overflow: hidden;
}

.e-main-menu__inner.show {
  display: block !important;
  visibility: visible !important;
  transition-delay: .2s !important;
}

.eds-account-menu a {
  color: white !important;

  &:hover {
    color: black !important;
  }
}

.e-header__menu .e-sub-menu.e-tab-menu .e-nested-menu li a:hover {
  color: black;
}

.e-sub-menu__link,
.e-sub-menu__next,
.e-sub-menu__title,
.menu-navigate-icon,
.icon {
  cursor: default;
}

body .hydrated .e-sub-menu__title a:not(.btn):hover,
body .hydrated .e-sub-menu__title a:not(.btn):hover:visited,
body .hydrated .e-sub-menu__title a:not([slot=cta]):hover,
body .hydrated .e-sub-menu__title a:not([slot=cta]):visited {
  color: black;
}